import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPictreeDataReportTsuruTrend,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
// import ReportTsuru from "components/PicTree/Home/ReportTsuru";
import TsuruSummary from "components/PicTree/Report/TsuruSummary";
import TsuruKubunPie from "components/PicTree/Report/TsuruKubunPie";
import LineChartPictreeReportTsuru from "components/Charts/LineChartPictreeReportTsuru";
import ChartConfig from "utils/ChartConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreeReportTsuruSummary = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTree,
  homeDataReportTsuru,
  reportTsuruTrend,
  getPictreeDataReportTsuruTrend,
}) => {
  const classes = useStyles();
  const [chartState, setChartState] = useState(true);
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (dateRangePicTree[0] !== null && dateRangePicTree[1]!== null
      && initialDataCall) {
      //getPictreeDataReportTsuruTrend();
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée TEPCO</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">報告モード</Typography>
              <Typography variant="body1">ツルツタ報告</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <C.CalendarRangePicker mDate={"2024/04/13"} page="pictree" pictree />
          </Grid>
        </Grid>

        {/* <Grid container spacing={0} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <ReportTsuru />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid> */}

        <Grid container direction="row" justifyContent="center" spacing={0} style={{ marginTop: 0 }}>
          <Grid item xs={12} md={12} lg={11}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <TsuruSummary />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container justifyContent="center" spacing={0} style={{ marginTop: 16 }}>
          <Grid item xs={12} md={12} lg={11}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={4}>
                      <TsuruKubunPie
                        title={`ツルツタ電柱達成率`}
                        subtext={homeDataReportTsuru.ledgerCount !== undefined
                          ? `全数：${homeDataReportTsuru.ledgerCount + homeDataReportTsuru.totalPlantAssetReg - homeDataReportTsuru.ledgerCount}`
                          : "全数 : --"
                        }
                        data={[
                          { value: homeDataReportTsuru.ledgerCount, name: "ツルツタ撮影数" },
                          { value: homeDataReportTsuru.totalPlantAssetReg - homeDataReportTsuru.ledgerCount, name: "未撮影数"},
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={4}>
                      <TsuruKubunPie
                        title="ツルツタ電柱区分"
                        subtext={homeDataReportTsuru.countLedgerAndReport !== undefined
                          ? `全数：${homeDataReportTsuru.countLedgerAndReport + homeDataReportTsuru.countLedgerAndNoReport}`
                          : "全数 : --"
                        }
                        data={[
                          { value: homeDataReportTsuru.countLedgerAndReport, name: "報告あり" },
                          { value: homeDataReportTsuru.countLedgerAndNoReport, name: "報告なし" },
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={4}>
                      <TsuruKubunPie
                        title="通常電柱区分"
                        subtext={homeDataReportTsuru.countNoLedgerAndReport !== undefined
                          ? `全数：${homeDataReportTsuru.countNoLedgerAndReport + homeDataReportTsuru.countNoLedgerAndNoReport}`
                          : "全数 : --"
                        }
                        data={[
                          { value: homeDataReportTsuru.countNoLedgerAndReport, name: "報告あり" },
                          { value: homeDataReportTsuru.countNoLedgerAndNoReport, name: "報告なし" },
                        ]}
                      />
                    </Grid>
                  </Grid>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* <Grid container justifyContent="center" spacing={0} style={{ marginTop: 16 }}>
          <Grid item xs={12} md={12} lg={11}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {pageTopLoader ? (
                        <div className={classes.loaderBox}>
                          <img
                            className={classes.loaderBarImg}
                            src={`/static/images/loader-bar.gif`}
                          />
                        </div>
                      ) : chartState ? (
                        reportTsuruTrend.length > 0 ? (
                          <LineChartPictreeReportTsuru
                            legend={ChartConfig.legendPicTreeReportTsuruTrend}
                            lblSaveImage={""}
                            xAisData={reportTsuruTrend[0]["date"]}
                            seriesData={reportTsuruTrend}
                            chartType={"bar"}
                          />
                        ) : (
                          <div className={classes.selectGameTxt}>
                            <Chip
                              label="No Data"
                              style={{
                                color: V.textColor,
                                backgroundColor: V.placeholderColor,
                              }}
                            />
                          </div>
                        )
                      ) : null}
                    </Grid>
                  </Grid>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid> */}

      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeReportTsuruSummary.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTree: state.page.dateRangePicTree,
  homeDataReportTsuru: state.pictree.homeDataReportTsuru,
  reportTsuruTrend: state.pictree.reportTsuruTrend,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPictreeDataReportTsuruTrend: (param) => dispatch(getPictreeDataReportTsuruTrend(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeReportTsuruSummary));
